import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/peanut/client_back.webp";

function Clienthad() {
  return (
    <section
      className="client_had client_peanut p-100 text_peanut"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>The Client</span> Had?
            </h2>
            <p>
              The client wanted to create an app specifically for dog owners in
              the US that actively focuses on community building. They needed
              the technical expertise to refine and conceptualize the idea and
              that’s exactly where TekRevol came in.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Clienthad;
